<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    @close="$emit('close')"
  >
    <div class="book-now-inputs flex flex-col gap-3 px-3">
      <div class="-mt-4 text-left">
        <h4 class="text-xl text-steel-1100">
          {{ type === 'edit' ? 'Edit Offer' : 'Place Offer' }}
        </h4>
      </div>

      <div class="mb-4 flex flex-col gap-4">
        <div>
          <p class="pl-2 text-left text-sm font-semibold text-steel-800">
            Offer
          </p>
          <div class="flex">
            <InputComponent
              input-label="price"
              wrapper-class="flex bg-white text-sm items-center h-10 gap-1.5 px-2 rounded-r-none w-10/12"
              placeholder="Enter Rate"
              :default-input-value="price"
              :value="price"
              @input-change="handlePrice"
            />

            <div
              class="border-l-none -mt-[1px] flex h-[42px] w-2/12 items-center justify-center rounded-r-md border border-steel-300 font-normal text-steel-700"
            >
              {{ ratePerMile }}
            </div>
          </div>
        </div>

        <div>
          <p class="pl-2 text-left text-sm font-semibold text-steel-800">
            Expiration
          </p>
          <InputComponent
            input-label="expiration"
            wrapper-class="flex bg-white text-sm items-center h-10 gap-1.5 px-2"
            placeholder=""
            :default-input-value="form.expiration"
            :value="form.expiration"
            @input-change="handleInput"
          />
        </div>
      </div>

      <div class="my-4 flex justify-end gap-4">
        <ButtonComponent @click="handleCancel">{{
          type === 'edit' ? 'Withdraw Offer' : 'Not Now'
        }}</ButtonComponent>
        <ButtonComponent
          :variant="type === 'edit' ? 'primary' : 'secondary'"
          class="flex min-w-[110px] justify-center"
          :disabled="isSubmitButtonDisabled"
          @click="handlePlaceOffer"
        >
          <svg
            v-if="isLoading"
            class="loading relative h-5 w-full"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M16 1V7L20 4L16 1Z"
              fill="currentColor"
            />
            <path
              d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
              stroke="currentColor"
              stroke-width="3"
            />
          </svg>
          <p v-else>{{ type === 'edit' ? 'Update Offer' : 'Place Offer' }}</p>
        </ButtonComponent>
      </div>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, watch } from 'vue';
import { useStore } from 'vuex';
import { BottomSheet, InputComponent, ButtonComponent } from '@/components';
import { BookLoadNotification } from '@/components/loads';
import { formatPrice } from '@/utils/currency.js';

const store = useStore();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'new',
    validator: (v) => ['new', 'edit'].includes(v),
  },
  offer: {
    type: Object,
  },
});

const emit = defineEmits(['close']);

const form = ref({
  expiration: '',
});

const price = ref('');
watch(
  () => props?.visible,
  (newVal) => {
    if (newVal) {
      console.log('? HUH', props);
      price.value = formatPrice(props?.offer?.rate, 0);
    }
  }
);

const ratePerMile = computed(() => {
  return formatPrice(props?.offer?.rate_in_dollars);
});

const isLoading = ref(false);

const handlePrice = (value) => {
  price.value = value;
};

const handleInput = (value, name) => {
  form.value[name] = value;
};

const isSubmitButtonDisabled = computed(() => false);

const handleCancel = () => {
  if (props?.type === 'edit') {
    // withdraw offer here, then close
    emit('close');
  } else {
    emit('close');
  }
};

const handlePlaceOffer = async () => {
  console.log('Handle Place Offer');
  isLoading.value = true;

  if (props?.type === 'edit') {
    const editRes = await store.dispatch('loads/editOffer', {
      id: props?.offer?.id,
      params: {
        rate: price?.value?.replace('$', ''),
        expires_at: form?.value?.expiration || props?.offer?.expires_at,
      },
    });

    if (editRes?.status === 200) {
      // change text in notification for EDIT
      await store.dispatch('toast/addToast', {
        component: BookLoadNotification,
        props: {
          visible: true,
          type: 'success',
        },
      });
    }

    emit('close');
    isLoading.value = false;
  } else {
    await store.dispatch('toast/addToast', {
      component: BookLoadNotification,
      props: {
        visible: true,
        type: 'success',
      },
    });

    emit('close');
    isLoading.value = false;
  }

  //   // if error
  //   // await store.dispatch('toast/addToast', {
  //   //   component: BookLoadNotification,
  //   //   props: {
  //   //     visible: true,
  //   //     type: 'error',
  //   //   },
  //   //   manuallyClose: true,
  //   // });

  //   // emit('close');
  //   // isLoading.value = false;
};
</script>
